import { render, staticRenderFns } from "./VoteElection.vue?vue&type=template&id=c3b8525e&scoped=true&"
import script from "./VoteElection.vue?vue&type=script&lang=js&"
export * from "./VoteElection.vue?vue&type=script&lang=js&"
import style0 from "./VoteElection.vue?vue&type=style&index=0&id=c3b8525e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b8525e",
  null
  
)

export default component.exports